import { Outlet } from "react-router-dom";
import { Layout } from "antd";
import Navbar from "./adminNavbar";
import { useGetCompanyQuery } from "@/services/api/company/companyApi";

const { Content } = Layout;

const AdminAuthLayout = () => {
  const { data: companyData } = useGetCompanyQuery();
  const companyLogo = companyData?.[0]?.url;
  let showLogo = true;
  return (
    <Layout className="min-h-screen bg-gray-50">
      {/* <Navbar showLogo={showLogo} /> */}
      {/* <Content className="bg-gray-50 p-6 min-h-[calc(100vh-80px)]"> */}
      <div>
        <img src={companyLogo} alt="Logo" className="h-16 mx-auto my-4" />
      </div>
      <Content className="bg-gray-50 p-6 h-full display-flex justify-center items-center">
        <Outlet />
      </Content>
    </Layout>
  );
};

export default AdminAuthLayout;
